import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionPrecioContent } from './components/GestionPrecioContent';

export default function GestionPrecio() {
    return (
        <MainContent
            component={<GestionPrecioContent />}
            titulo='Precio contrato'
            noBackground
            tableMaxWidth
        />
    );

};
